/* src/app/private/modules/packages/packages.component.scss */
/*# sourceMappingURL=packages.component.css.map */
